import React from 'react';
import QuickComment from './quick_comment';
import QuickProductImage from './quick_product_image';

import './index.less';

/**
 * globalDataKeys: [
              'product',
              'i18n',
           'extend.promoConfig',
           'seller.companyId'
            ],
 */
interface IQuickLeft {
  i18n: DetailTypes.i18n;
  product: DetailTypes.Product;
  promoConfig: string;
  companyId: number;
}
export default function QuickDetailLeft(props: IQuickLeft) {
  const { i18n, product, promoConfig, companyId } = props;
  const { productId, subject } = product;

  //  大促预热相关
  const promotionAtmosphere = () => {
    //在extendData里的大促预热
    const promotionInfo = promoConfig && JSON.parse(promoConfig);
    if (promotionInfo?.DETAIL_TITLE_PREPEND_ATOMOSPHERE?.length > 0) {
      return <img src={promotionInfo?.DETAIL_TITLE_PREPEND_ATOMOSPHERE[0]?.materialJSON?.image} />;
    } else {
      return null;
    }
  };
  return (
    <div className="detail-quick-view-left">
      {/* 大促标 + 标题 */}
      <div className="detail-quick-view-left-title">
        <h1 title={subject}>
          {promotionAtmosphere()}
          {subject}
        </h1>
      </div>
      <div className="detail-quick-view-left-comment">
        <QuickComment i18n={i18n} productId={productId} companyId={companyId} />
      </div>
      <div className="detail-quick-view-product-img">
        <QuickProductImage product={product} />
      </div>
    </div>
  );
}
